import React, { useCallback, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { CookieModalContainer } from "./CookieModalStyled";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

export interface Props {
	cookieName: string;
	successExpires: number;
	failExpires: number;
	content: string;
	externalLink?: boolean;
	link: string;
	imageBackgroundURL?: string;
	size?: "S" | "L";
	buttonText?: string;
}

const CookieModalWrapper: React.FC<Props> = ({ cookieName, successExpires, failExpires, content, externalLink, link, imageBackgroundURL, size, buttonText,...props }: Props) => {
	const [showModal, setShowModal] = useState(true);
	const show = useCallback(() => {
		const cookieExists = Cookies.get(cookieName) !== undefined;
		if (cookieExists) {
			setShowModal(false);
		} else {
			setShowModal(true);
		}
	}, []);

	const handleCookie = (isSuccess: boolean) => {
		if (isSuccess) {
			Cookies.set(cookieName, "yes", { expires: successExpires });
		} else {
			Cookies.set(cookieName, "not", { expires: failExpires });
		}
		setShowModal(false);
	};

	useEffect(() => {
		show();
	}, []);

	return (
		<CookieModalContainer
			cookieName={cookieName} //
			successExpires={successExpires}
			failExpires={failExpires}
			content={content}
			link={link}
			imageBackgroundURL={imageBackgroundURL}
			size={size}>
			<div className={`overlay ${showModal ? "show" : ""}`} onClick={() => handleCookie(false)}></div>
			<div className={`modalBody ${showModal ? "show" : ""}`}>
				<span className='btnClose' onClick={() => handleCookie(false)}>
					<FaTimes size={24} color='#CCC' />
				</span>
				<div dangerouslySetInnerHTML={{ __html: content }}></div>
				{externalLink ? (
					<a className='cta' href={link} target='_blank' onClick={() => handleCookie(true)}>
						Participar
					</a>
				) : (
					<Link className='cta' to={link} onClick={() => handleCookie(true)}>
						{buttonText ? buttonText : "Participar"}
					</Link>
				)}
			</div>
		</CookieModalContainer>
	);
};

CookieModalWrapper.defaultProps = {};

export { CookieModalWrapper as CookieModal };
